import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { addAccountFeatureModule } from "modules/core/api/account_features";

import { FEATURE_MODULES_QUERY_KEY } from "modules/user/hooks/queries/useFeatureModulesQuery";

export const useAddAccountFeatureModuleMutation = () => {
  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();

  const mutationResults = useMutation(addAccountFeatureModule, {
    onSuccess: () => {
      enqueueSnackbar("Module added succesfully", { variant: "success" });

      queryClient.invalidateQueries(FEATURE_MODULES_QUERY_KEY);
    },
    onError: () => {
      enqueueSnackbar("Couldn't add module. Try again", { variant: "error" });
    }
  });

  return mutationResults;
};
